import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiTrash2, FiCalendar, FiClock } = FiIcons;

export default function TrashEventModal({ event, onClose, onSave }) {
  const [formData, setFormData] = useState({
    type: 'restmüll',
    date: '',
    notes: '',
    reminder: true
  });

  const trashTypes = [
    { value: 'restmüll', label: 'Restmüll (Schwarz)', color: 'bg-gray-700' },
    { value: 'biomüll', label: 'Biomüll (Braun/Grün)', color: 'bg-green-600' },
    { value: 'papier', label: 'Papier (Blau)', color: 'bg-blue-600' },
    { value: 'gelberSack', label: 'Gelber Sack/Tonne', color: 'bg-yellow-500' },
    { value: 'sperrmüll', label: 'Sperrmüll', color: 'bg-orange-600' },
    { value: 'schadstoff', label: 'Schadstoffmobil', color: 'bg-red-600' }
  ];

  useEffect(() => {
    if (event) {
      setFormData({
        type: event.type || 'restmüll',
        date: event.date ? event.date.split('T')[0] : '',
        notes: event.notes || '',
        reminder: event.reminder !== false
      });
    } else {
      setFormData(prev => ({ ...prev, date: new Date().toISOString().split('T')[0] }));
    }
  }, [event]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      ...formData,
      date: new Date(formData.date).toISOString()
    });
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="fixed inset-0 bg-black bg-opacity-30" onClick={onClose} />
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="relative bg-white rounded-xl shadow-xl max-w-md w-full p-6"
        >
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-semibold text-gray-900">
              {event ? 'Termin bearbeiten' : 'Neuer Abfuhrtermin'}
            </h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
              <SafeIcon icon={FiX} className="w-6 h-6" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Abfallart</label>
              <div className="grid grid-cols-2 gap-2">
                {trashTypes.map(type => (
                  <div
                    key={type.value}
                    onClick={() => setFormData({ ...formData, type: type.value })}
                    className={`cursor-pointer p-2 rounded-lg border-2 text-sm flex items-center space-x-2 transition-all ${
                      formData.type === type.value 
                        ? 'border-blue-500 bg-blue-50' 
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <div className={`w-3 h-3 rounded-full ${type.color}`} />
                    <span className="truncate">{type.label}</span>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <SafeIcon icon={FiCalendar} className="w-4 h-4 inline mr-2" />
                Datum
              </label>
              <input
                type="date"
                value={formData.date}
                onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                className="w-full border border-gray-300 rounded-lg px-3 py-2"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Notizen</label>
              <input
                type="text"
                value={formData.notes}
                onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                className="w-full border border-gray-300 rounded-lg px-3 py-2"
                placeholder="z.B. Tonne muss um 6 Uhr draußen sein"
              />
            </div>

            <div className="flex items-center space-x-2 pt-2">
              <input
                type="checkbox"
                id="reminder"
                checked={formData.reminder}
                onChange={(e) => setFormData({ ...formData, reminder: e.target.checked })}
                className="w-4 h-4 text-blue-600 rounded"
              />
              <label htmlFor="reminder" className="text-sm text-gray-700">
                Erinnerung am Vorabend aktivieren
              </label>
            </div>

            <div className="flex justify-end space-x-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
              >
                Abbrechen
              </button>
              <button
                type="submit"
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
              >
                Speichern
              </button>
            </div>
          </form>
        </motion.div>
      </div>
    </div>
  );
}